import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  z-index: 2000;
  right: 0;
  top: 0;
  padding: 30px;
  overflow: hidden;
`;

export default Container;
